import useForm from 'tennders-common/form/hooks/useForm'
import { useEffect, useState } from 'react'
import { defaultLineForm } from 'tennders-finance/cost-invoice/components/multiple-cost-invoice/MultipleCostInvoiceDiscountRow'
import { apiGet } from 'tennders-stracture/libs/api'
import PubSub from 'pubsub-js'
import { roundDecimals } from 'tennders-stracture/libs/utils'

const useMultipleCostInvoiceDiscountRow = ({ costPrice, index, initialErrors, onFormChange }) => {
  const { form, setform: setForm, errors } = useForm({ initialForm: defaultLineForm, initialErrors })
  const [transaction, setTransaction] = useState(null)
  const onTransactionChange = (transaction) => {
    setTransaction(transaction)
    setForm({ ...form, transactionId: transaction.id, agreedPrice: transaction.totalPrice })
  }
  useEffect(() => {
    console.info('changed', form)
    if (onFormChange) {
      onFormChange(index, form)
    }
  }, [onFormChange, index, form])

  const processForm = (key, value, form, cost) => {
    const newForm = { ...form, [key]: value }
    if (key === 'vatPercentage' || key === 'amount' || key === 'value' || key === 'applyTo') {
      newForm.amount = roundDecimals(Math.abs((newForm.value * costPrice)) / 100)

      const percentage = newForm.vatPercentage ? (parseFloat(newForm.vatPercentage) / 100) : 0
      const amount = parseFloat(newForm.amount)
      const vatAmount = amount * percentage
      newForm.totalAmount = amount + vatAmount
      newForm.vatAmount = vatAmount
    }
    return newForm
  }

  useEffect(() => {
    console.info('value changed', form)
    setForm(prevState => processForm('value', prevState.value || 0, prevState, costPrice))
  }, [costPrice, form?.value])

  const onChange = (key, value) => {
    setForm(prev => processForm(key, value, prev, costPrice))
  }

  const fetchTransactionDetail = async (id) => {
    const data = await apiGet('/transactions/' + id, { query: { attributes: '{id,referenceNumber,createdAt {d}, matchedTruck{totalPrice, bookRate, id, paymentTerm{days}, cmrDocument{name, fullUri}},salesInvoice{id, uniqueFileName}, hasSalesInvoice, costInvoices{id}}' } })
    setTransaction(data)
    onChange('transactionId', id)
  }

  useEffect(() => {
    const unsubscribe = PubSub.subscribe(`multiple-cost-invoice-discount:${index}:change`, (msg, data) => {
      if (data.transactionId) {
        fetchTransactionDetail(data.transactionId)
      }
      setForm(prevState => ({ ...prevState, ...data }))
    })
    return () => PubSub.unsubscribe(unsubscribe)
  }, [index])

  return {
    onChange,
    form,
    setForm,
    errors,
    onTransactionChange,
    transaction

  }
}

export default useMultipleCostInvoiceDiscountRow
